var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var autocomplete = require('js-autocomplete');
var ordinal = require('ordinal');
var indicator = require('ordinal/indicator');
var stable = require('stable');
var slugify = require('../utils/slugify.js');
var updateUrlParameter = require('../utils/updateUrlParameter.js');

function Compare(el) {
  var $el = $(el),
      $tools = $el.find('#compare-tools'),
      $table = $el.find('#compare-table'),
      $companyData = '/wp-content/themes/justcapital/assets/data/companies.json',
      $industryData = '/wp-content/themes/justcapital/assets/data/industries.json',
      $currentYear = $el.attr('data-year'),
      $companies = {},
      $companyNames = [],
      $industries = {},
      $comparing = [],
      $numComparing = 0;

  // Get all the company data
  $.getJSON($companyData, function(data) {
    $companies = data;
    listCompanies($companies);
  });

  $el.find('#compare-add').on('click', function(e) {
    e.preventDefault();
    $tools.show();
    $tools.find('input[name=compare-search]').focus();
  });

  $el.find('#close-compare-tools').on('click', function(e) {
    e.preventDefault();
    $tools.hide();
  });

  $table.on('click', '.close-button', function(e) {
    e.preventDefault();
    var $ticker = $(this).closest('.cell-header').attr('data-company')
    $table.find('*[data-company=' + $ticker + ']').remove();
    $table.find('#compare-add').show();
    if ($numComparing === 1) {
      $tools.removeClass('overlay').addClass('default').show();
      $table.removeClass('compare-table--' + ($numComparing + 1) + '-col').removeClass('active');
    } else {
      $tools.removeClass('default').addClass('overlay');
      $table.removeClass('compare-table--' + ($numComparing + 1) + '-col').addClass('compare-table--' + $numComparing + '-col').addClass('active');
    }
    $numComparing--;
    updateUrl($ticker);
  });

  function updateUrl(ticker) {
    if ($comparing.indexOf(ticker) >= 0) {
      $comparing.splice($comparing.indexOf(ticker), 1);
    } else {
      $comparing.push(ticker);
    }
    if (history.pushState) {
      var $newUrl = window.location.origin + updateUrlParameter(window.location.pathname, 'co', $comparing.toString());
      window.history.pushState({path: $newUrl}, '', $newUrl);
    }
  }

  // Populate list of companies in search field
  // When a company is selected, add it to the comparison table
  // If the URL has a query string param on load, show preselected companies
  function listCompanies(companies) {
    // Get all the industry data so we have it ready to show for a selected company
    $.getJSON($industryData, function(data) {
      $industries = data;
    });

    // Load the page with companies preselected
    if (window.location.search) {
      $tools.hide();

      // Get companies to show from URL query string params
      var params = new Array();
      var self = window.location.toString();
      var querystring = self.split("?");
      if (querystring.length > 1) {
        var pairs = querystring[1].split("&");
        for (i in pairs) {
          var keyval = pairs[i].split("=");
          params[keyval[0]] = keyval[1];
        }
      }

      var $companiesToLoad = params['co'].split(',');
      $companiesToLoad.forEach(function(company, i) {
        addCompany(company);
      });
    }

    // Put all the company names and ticker symbols
    // in an array that will go into the search field
    for (var i = 0, length = companies.length; i < length; i++) {
      $companyNames.push([companies[i].ticker, companies[i].name, companies[i].industry]);
    }
    // Alphabetize the company names
    function alphabetize(y,x) {
      return y[1].localeCompare(x[1]);
    }
    stable.inplace($companyNames, alphabetize);

    new autocomplete({
      selector: 'input[name=compare-search]',
      minChars: 0,
      source: function(term, suggest) {
        term = term.toLowerCase();
        var choices = $companyNames,
            suggestions = [];
        for (i = 0; i < choices.length; i++)
          if (~(choices[i][1]+' '+choices[i][0]).toLowerCase().indexOf(term)) suggestions.push(choices[i]);
        suggest(suggestions);
      },
      renderItem: function(item, search) {
        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
        return '<div class="autocomplete-suggestion" data-ticker="'+item[0]+'" data-val="'+item[1]+'">' + item[1].replace(re, "<b>$1</b>") + '<span>'+item[2]+'</span>' +'</div>';
      },
      onSelect: function(e, term, item) {
        e.preventDefault();
        addCompany(item.getAttribute('data-ticker'));
        $tools.hide().find('input[name=compare-search]').val('');
      }
    });
  }

  function addCompany(ticker) {
    var $ticker = ticker,
        $company;
    $companies.forEach(function(company) {
      if (company.ticker === $ticker) $company = company;
    });
    $numComparing++;
    updateUrl($ticker);

    $tools.removeClass('default').addClass('overlay');
    $table.removeClass('compare-table--' + $numComparing + '-col').addClass('compare-table--' + ($numComparing + 1) + '-col').addClass('active');
    if ($numComparing === 3) {
      $table.find('#compare-add').hide();
    } else {
      $table.find('#compare-add').show();
    }

    function addCell(type, content, issue) {
      var $issueClass = issue ? ' compare-issue' : '';
      $table.find('.cell-' + type).filter(':last').after('<div class="compare-table__cell cell-' + type + $issueClass + '" data-company="' + $ticker + '">' + content + '</div>');
    }

    var $industry = $company.industry,
        $score = $company.scores.overall ? Math.round($company.scores.overall * 10) / 10 : '',
        $rank = parseInt($company.rank.overall),
        $ordinalRank = $rank ? $rank + '<span>' + indicator($rank) + '</span>' : null;
        $industryRank = parseInt($company.rank.industry),
        $link = '/companies/' + slugify($company.name),
        $topSeals = '',
        $industrySeals = '',
        $just100 = '',
        $industryLeader = '';

    if ($rank && $rank <= 100) {
      $topSeals = $currentYear;
      $just100 = '<span></span> JUST 100 <strong>' + $topSeals + '</strong>';
    }
    if ($industryRank == 1) {
      $industrySeals = $currentYear;
      $industryLeader = '<span></span> Industry Leader <strong>' + $industrySeals + '</strong>';
    }
    addCell('awards', '<p id="company-seals" class="company-seal">' + $just100 + '</p><p id="industry-seals" class="company-seal">' + $industryLeader + '</p>');

    for (var p = 1; p < 4; p++) {
      var $prevYear = $currentYear - p;
      $.ajax({
        url: '/wp-content/themes/justcapital/assets/data/companies-' + $prevYear + '.json',
        async: false,
        success: function(data) {
          var $companyLastYear,
              $prevYearRank,
              $prevYearIndustryRank;
          data.forEach(function(c) {
            if (c.ticker === $company.ticker) $companyLastYear = c;
          });
          if ($companyLastYear) {
            $prevYearRank = $companyLastYear.rank.overall;
            $prevYearIndustryRank = $companyLastYear.rank.industry;
          }
          if ($prevYearRank && $prevYearRank <= 100) {
            if ($topSeals) {
              $("div[data-company='"+$company.ticker+"']").find('#company-seals strong').append(', ' + $prevYear);
            } else {
              $topSeals = $prevYear;
              $("div[data-company='"+$company.ticker+"']").find('#company-seals').append('<span></span> JUST 100 <strong>' + $topSeals + '</strong>');
            }
          }
          if ($prevYearIndustryRank == 1) {
            if ($industrySeals) {
              $("div[data-company='"+$company.ticker+"']").find('#industry-seals strong').append(', ' + $prevYear);
            } else {
              $industrySeals = $prevYear;
              $("div[data-company='"+$company.ticker+"']").find('#industry-seals').append('<span></span> Industry Leader <strong>' + $industrySeals + '</strong>');
            }
          }
        }
      });
    }

    // Total number of companies in the industry
    var $industryTotal = $companies.filter(function(companies) {
      return companies.industry === $industry;
    });

    addCell('header', '<a class="close-button" href="#"></a><p><img src="/wp-content/themes/justcapital/assets/img/company-logos/' + $ticker + '.png" alt="" /></p><h2>' + $company.name + '</h2><p><a href="' + $link + '" class="compare-link">View details</a></p>');

    addCell('industry', '<a href="/rankings?industry=' + slugify($industry) + '">' + $industry + '</a>');

    var $rankContent = $company.data_clarification ? '' : '<p class="rank-badge"><span class="ordinal">' + $ordinalRank + '</span><span>of ' + $companies.length + ' companies</span></p>';
    if (!$ordinalRank) $rankContent = '<div class="rank-note"><p>Bottom 10%</p><p>' + $company.name + ' is ranked in the bottom 10% of companies overall. We don\'t display overall rankings or scores for the bottom 10%.</p></div>';
    addCell('rank-overall', $rankContent);

    addCell('subheader', '');

    var $industryRankContent = $company.data_clarification ? '' : '<span class="ordinal">' + $industryRank + '<span>' + indicator($industryRank) + '</span>' + '</span> of ' + $industryTotal.length + ' ' + $industry + ' companies';
    addCell('rank-industry', $industryRankContent);

    var $scoreContent = $company.data_clarification ? '' : '<p class="ordinal">' + $score + '</p>';
    addCell('score-overall', $scoreContent);

    $table.find('.issue-cell').each(function() {
      // Company's overall rank for each issue
      function sort(x,y) {
        return y.scores[$shortname].overall - x.scores[$shortname].overall;
      }
      var $shortname = $(this).attr('data-issue');
      var $companiesSortedByIssue = stable($companies, sort);
      var $clarification;

      if ($company.data_clarification) {
        var $clarificationMetric = $company.data_clarification.datapoints[0].toLowerCase();
        if ($shortname === $clarificationMetric.split('.')[0]) $clarification = true;
      }

      if ($clarification) {
        addCell('score-' + $shortname, '<p class="clarification-note">Data Clarification</p>', true);
      } else {
        var $issueRank = -1;
        for (var i = 0; i < $companiesSortedByIssue.length; i++) {
          if ($companiesSortedByIssue[i].scores[$shortname].overall == $company.scores[$shortname].overall) {
            $issueRank = i;
            break;
          }
        }
        $issueRank = $issueRank + 1;

        // Company's rank in its industry for each issue
        var $filtered = $companiesSortedByIssue.filter(function(companies) {
          return companies.industry === $industry;
        });
        var $industryRank = -1;
        for (var i = 0; i < $filtered.length; i++) {
          if ($filtered[i].scores[$shortname].overall == $company.scores[$shortname].overall) {
            $industryRank = i;
            break;
          }
        }
        $industryRank = $industryRank + 1;

        addCell('score-' + $shortname, '<p><span class="ordinal">' + $issueRank + '<span>' + indicator($issueRank) + '</span></span> overall</p><p><span class="ordinal">' + $industryRank + '<span>' + indicator($industryRank) + '</span>' + '</span> of ' + $industryTotal.length + '</p>', true);
      }
    });

    addCell('link', '<a href="' + $link + '" class="compare-link">View details</a>');
  }
}

module.exports = Compare;
